module.exports = __webpack_public_path__ + "static/media/durp_poz2331.33532433.png";